import { render, staticRenderFns } from "./BankAccountEdit.vue?vue&type=template&id=0fe21645&"
import script from "./BankAccountEdit.vue?vue&type=script&lang=js&"
export * from "./BankAccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports